import en from './strings.en';

const ru = {
    createBoardHeader: 'Создайте Площадку',
    createBoard: 'Создать площадку',
    whatIsBoards: 'Подробнее о площадках ATI.SU',
    boardsDescription: 'Участники ATI.SU создают площадки и вступают на них, чтобы быстро найти перевозчика для груза или загрузку для транспорта.'
};

export default { ru, en: { ...ru, ...en} };
